const RETURN_TO_ORIGIN = "http://return-to.invalid";

const signInPaths = new Set([
  "/provider",
  "/provider/dashboard",
  "/provider/floor",
  "/provider/schedule",
  "/provider/register",
  "/provider/customers",
  "/provider/venue-setup",
  "/provider/business",
  "/admin",
  "/provider/tournaments",
  "/legal/account-deletion",
]);

/** Returns a literal, supported workspace or account-recovery path and query, never a URL or arbitrary app route. */
export function getValidatedSignInReturnTo(value: string | null | undefined): string | null {
  if (
    !value ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\") ||
    value.includes("#") ||
    value.includes("//") ||
    value.includes(":") ||
    value.includes("@") ||
    /[\u0000-\u001f]/.test(value)
  ) {
    return null;
  }

  let parsed: URL;
  try {
    parsed = new URL(value, RETURN_TO_ORIGIN);
  } catch {
    return null;
  }

  const rawPathname = value.slice(0, value.indexOf("?") === -1 ? value.length : value.indexOf("?"));
  if (
    parsed.origin !== RETURN_TO_ORIGIN ||
    parsed.hash ||
    rawPathname.includes("%") ||
    parsed.pathname !== rawPathname ||
    !signInPaths.has(parsed.pathname)
  ) {
    return null;
  }

  return `${parsed.pathname}${parsed.search}`;
}
